import { render, staticRenderFns } from "./transportSwitch.vue?vue&type=template&id=edfd02ac&scoped=true"
import script from "./transportSwitch.vue?vue&type=script&lang=ts&setup=true"
export * from "./transportSwitch.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./transportSwitch.vue?vue&type=style&index=0&id=edfd02ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edfd02ac",
  null
  
)

export default component.exports